import * as React from "react";
import { forwardRef } from "react";
const SvgComponent = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", Object.assign({
  viewBox: "0 0 24 25",
  fill: "currentColor",
  "aria-hidden": "true",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, /*#__PURE__*/React.createElement("path", {
  d: "M11.25 21.735v-2.25a.75.75 0 1 1 1.5 0v2.25a.75.75 0 1 1-1.5 0m-4.023-4.227.531.53-1.592 1.591a.75.75 0 0 1-1.061-1.061l1.591-1.592zm11.668 1.06.051.057a.75.75 0 0 1-1.055 1.055l-.057-.051-1.592-1.591.531-.53.53-.531zm-12.199-1.59a.75.75 0 1 1 1.062 1.062zm9.546 0a.75.75 0 0 1 1.061 0l-1.061 1.062a.75.75 0 0 1 0-1.062M15 12.735a3 3 0 1 0-6 0 3 3 0 1 0 6 0m-9.75-.75a.75.75 0 1 1 0 1.5H3a.75.75 0 1 1 0-1.5zm15.75 0a.75.75 0 1 1 0 1.5h-2.25a.75.75 0 1 1 0-1.5zM7.758 7.432a.75.75 0 1 1-1.062 1.062zm9.546 1.062a.75.75 0 1 1-1.061-1.062zM5.105 5.841a.75.75 0 0 1 1.061 0l1.592 1.591-.531.53-.53.531-1.591-1.592a.75.75 0 0 1 0-1.061zm12.729 0a.75.75 0 0 1 1.061 1.061l-1.591 1.592-.53-.531-.531-.53zm-6.584.145v-2.25a.75.75 0 1 1 1.5 0v2.25a.75.75 0 1 1-1.5 0m5.25 6.75a4.5 4.5 0 1 1-9 0 4.5 4.5 0 1 1 9 0"
}));
const ForwardRef = forwardRef(SvgComponent);
export const SunIcon = ForwardRef;